import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { getDownloadURL, ref, Storage } from '@angular/fire/storage';
import { from } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class StrideReviewService {
  constructor(private http: HttpClient, private storage: Storage) {}

  getReviewData(path: string) {
    const reviewDataFileRef = ref(this.storage, path);
    return from(getDownloadURL(reviewDataFileRef)).pipe(
      switchMap((url) => {
        return this.http.get(url);
      })
    );
  }
}
